import React from "react";
import { Route, Switch } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Auth from "../features/auth/Auth";
import SignupDone from "../features/auth/SignupDone";
import AccountActivation from "../features/auth/AccountActivation";
import PasswordResetConfirm from "../features/auth/PasswordResetConfirm";
import PasswordReset from "../features/auth/PasswordReset";
import { homeRoutes } from "./HomeRoutes";
import FooterLayout from "../containers/footer/FooterLayout";
import Page404 from "../features/page404/Page404";
import Top from "../features/top/Top";

//ログインページ
const Router: React.FC = () => {
  return (
    <Switch>
      <Route exact path="/signup_done">
        <SignupDone />
      </Route>
      <Route path="/password_reset">
        <PasswordReset />
      </Route>
      <Route path="/reset/:uid/:token/">
        <PasswordResetConfirm />
      </Route>
      <Route path="/account/confirm-email/:key">
        <AccountActivation />
      </Route>
      <Route exact path="/login">
        <Auth />
      </Route>
      <Route exact path="/">
        <Top />
      </Route>

      <Route
        path="/home"
        render={({ match: { url } }) => (
          <Switch>
            {homeRoutes.map((route) => (
              <Route
                key={route.path}
                exact={route.exact}
                path={`${url}${route.path}`}
              >
                <Grid container>
                  <Grid item xs={12} sm={8}>
                    {route.path === "*" ? (
                      <>{route.children}</>
                    ) : (
                      <FooterLayout>{route.children}</FooterLayout>
                    )}
                  </Grid>
                </Grid>
              </Route>
            ))}
          </Switch>
        )}
      ></Route>
      <Route path="*">
        <Page404 />
      </Route>
    </Switch>
  );
};

export default Router;
